import React,{useRef, useState, useEffect} from "react";
import { Button, Card, Badge, Dropdown, Row, Form, Col, Spinner} from "react-bootstrap";
import {formatDate} from "../utils/functions";
import * as yup from 'yup';
import * as formik from 'formik';
import vindrApi from "../utils/vindrapi";
import schemas from "../data/dataSchemas";
import Country from "../classes/Country";
import Select from "react-select";
import JSZip from 'jszip';
import fs from 'file-saver';
import {filenamify} from "../utils/functions";
import { PencilSimple } from "@phosphor-icons/react";

const { Formik } = formik;

class LibraryItem extends React.Component {

	
	
	constructor(props) {
		
		super(props);
		
		
		this.state = {
			edit: false,
			validated: false,
			status: {sent:null, message:''}
		};
		
	}

	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}

	handleOnKeyUp(e){
		if (e.key === 'Enter' || e.keyCode === 13) {
			this.handleOnBlur(e);
		}
		if (e.key === 'Escape' || e.keyCode === 27) {
			
			this.updateStatus({edit:false, buffer:this.state.value});
		}
	}
	componentDidMount(){
		if(this.element && this.state.edit)
			this.element.focus();
	}
	componentDidUpdate(){
		
	}
	handleOnSelect(item, alreadyUsed){
		
		if(this.props.onSelect)
			this.props.onSelect(item, alreadyUsed)
	}

	handleClose(data){
		this.updateStatus({edit:false, status:{sent:null, message:''}});
	};
	handleUpdate(data){
		if(this.props.onUpdate)
			this.props.onUpdate(data)
	}
	handleDownload(layer){
		
		var filePromises = [vindrApi.downloadLibLayer(layer.id)];
		const zip = new JSZip();
		
		Promise.all(filePromises).then((results)=>{
			results.forEach((f,k)=>{

				fs.saveAs(f, filenamify(layer.name)+'.gpkg');
				
			});

			
		});
	}
	handleDropDownClick(e){
		e.stopPropagation();
		
		var open = document.querySelector(".card-layer .dropdown.show");
		
		if(open){
			document.querySelector("body").dispatchEvent(new MouseEvent("click", {
				view: window,
				bubbles: true,
				cancelable: true,
			  }));
		}
		
	}
	handleSubmit(data){

		
		
		this.updateStatus({status:{sent:false, success:false, message:'updating layer...'}});
		//saveguard for testing
		if(data.countries){
			data.countries = data.countries.map((c)=>{return c.value});
			data.country = data.countries[0];
		}
		//console.log(setMainScenario);
		vindrApi.addToLibrary(this.props.item.id, data).then((response)=>{
			
			if(response.id){
				this.updateStatus({status:{sent:true, success:true, message:'Layer was edited'}});
				
				setTimeout(()=>{this.handleClose();this.handleUpdate(response)}, 2000); 
			}
			else
				this.updateStatus({status:{sent:true, success:false, message:'Error editing layer'}});
			
			
			
		}).catch((e)=>{
			this.updateStatus({status:{sent:true, success:false, message:'Error editing layer'}});
		});
		//this.updateStatus({sent:false, success:false, message:'Saving...'});
		
	};
	render() {
		
		var auto = this.state.edit ? 'autoFocus' : '';
		
		var dv = { name:this.props.item.name, description:this.props.item.description, countries:this.props.item.countries.map((a)=>{return {'label':a,'value':a}})};
		
		return (<>
			{this.state.edit &&
				<>
					<div className="fade modal-backdrop show"></div>
					<Card className="card-edit-layer" key={this.props.jkey+'f'}>
						<Card.Header>Edit layer details  <button onClick={(e)=>{this.handleClose(e);}} className="btn btn-close"></button></Card.Header>
						<Formik validationSchema={schemas.libraryLayer} onSubmit={this.handleSubmit.bind(this)} initialValues={dv}>	
							{({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
								<Form noValidate onSubmit={handleSubmit}>

									{this.state.status.sent === null ? (
										<React.Fragment>
											<Card.Body className="card-form">
												<Row>
													<Form.Group as={Col} md="12" className="mb-3" controlId="validationFormik00">
														<Form.Label className={schemas.libraryLayer.describe().fields.name ? 'required' : ''}>Title</Form.Label>
														<Form.Control type="text" name="name" placeholder="Layer title"   value={values.name} onChange={handleChange} isValid={touched.name && !errors.name} isInvalid={errors.name}/>
													</Form.Group>
												</Row>
												<Row>
													<Form.Group as={Col} md="12" className="mb-3" controlId="validationFormik00">
														<Form.Label className={schemas.libraryLayer.describe().fields.description ? 'required' : ''}>Description</Form.Label>
														<Form.Control as="textarea" name="description" placeholder="Layer description"   value={values.description} onChange={handleChange} isValid={touched.description && !errors.description} isInvalid={errors.description}/>
													</Form.Group>
												</Row>
												{this.props.item.vindrLibrary &&
												<Row>
													<Form.Group as={Col} xs="12" controlId="validationFormik00">
														<Form.Label>Country</Form.Label>
														<Select name="countries" isMulti options={Country.options} defaultValue={dv.countries} onChange={(sel)=>setFieldValue("countries", sel)}  isSearchable={false} placeholder="Countries" isValid={touched.country && !errors.country} isInvalid={errors.country}
															styles={{
															control: (baseStyles, state) => ({...baseStyles, borderColor: errors.countries ? 'var(--bs-form-invalid-border-color)' : 'var(--bs-border-color)',
															}),
														  }}
														/>
													</Form.Group>
												</Row>
												}
											</Card.Body>
											<Card.Footer className="card-buttons">
												<Button variant="primary" type="submit">Save</Button>
											</Card.Footer>
										</React.Fragment>
									) : (
									<Card.Body>
										<Row className="mb-3 dialog-feedback">
											<Col xs="12" className="dialog-feedback-icon text-center">
												{
												this.state.status.sent ?
													(this.state.status.success ? 
														(<i className="ri-checkbox-circle-line text-success"></i>)
														:
														(<i className="ri-error-warning-line text-warning"></i>)
													)
													:
													(<Spinner animation="border" variant="info" className="mt-5" />)
												}
											</Col>
											<Col xs="12" className="dialog-feedback-text mb-5">
												{this.state.status.message}
											</Col>
										</Row>
									</Card.Body>	
									)}
								</Form>
							)}	
						</Formik>
					</Card>
				</>
			}
			
				<Card key={this.props.jkey} className={"card-layer m-2 my-3 " +(this.props.used && !this.state.edit ? "used": "")} onClick={()=>{this.handleOnSelect(this.props.item, this.props.used);}}>

					{this.props.used && <Badge bg="primary" className="rounded"><i className="ri-check-line"></i> Added</Badge>}

					<Card.Img className={"card-img-top " + (this.props.item.image ? 'full' :  'contain')} src={this.props.item.image ? this.props.item.image :  '/images/no-image.png'}/>
					<Card.Body>
						<h6>
							<span title={this.props.item.name}>{this.props.item.name}</span>

							<Dropdown onClick={(e)=>{this.handleDropDownClick(e);}}>
								<Dropdown.Toggle className="p-0 px-1" variant="default">
									<i className="ri-more-2-fill"></i>
								</Dropdown.Toggle>
								<Dropdown.Menu>
									{!this.props.used &&
									<Dropdown.Item href="#" onClick={()=>{this.handleOnSelect(this.props.item, this.props.used);}}><i className="ri-map-2-line"></i> Add to map</Dropdown.Item>
									}
									{this.props.used &&
									<Dropdown.Item href="#" onClick={()=>{this.handleOnSelect(this.props.item, this.props.used);}}><i className="ri-map-2-line"></i> Remove from map</Dropdown.Item>
									}
									{false && !this.props.item.vindrLibrary &&
										<Dropdown.Item href="#" onClick={(e)=>{}}><i className="ri-community-line"></i> Move to Vindr library</Dropdown.Item>
									}
									{this.props.item.type == 'vector' &&
									<Dropdown.Item href="#" onClick={(e)=>{this.handleDownload(this.props.item)}}><i className="ri-download-2-line"></i> Download</Dropdown.Item>
									}
									{
										<Dropdown.Item href="#" onClick={(e)=>{e.stopPropagation(); this.updateStatus({edit:true});}} className="important"><PencilSimple size={14} /> Edit</Dropdown.Item>
									}
									{!this.props.item.vindrLibrary &&
										<Dropdown.Item href="#" onClick={(e)=>{this.props.onDelete()}} className="text-danger"><i className="ri-delete-bin-line"></i> Delete</Dropdown.Item>
									}
								</Dropdown.Menu>
							</Dropdown>

						</h6>
						<span className="description">{this.props.item.description}</span>
					</Card.Body>
					<Card.Footer>
						<div>{this.props.item.uploader}</div>
						<div>{formatDate(this.props.item.upload_date, 'short')}</div>
					</Card.Footer>
				</Card>
			</>
		)
		
		
	}
}

export default LibraryItem;